import React from 'react';

const NEW_PAYMENT_OPTION = 'newPayment';

const formatPaymentToken = (paymentType, paymentToken) => {
  if (!paymentToken) {
    return '';
  }
  if (paymentType === 'CREDIT_CARD') {
    return `${paymentToken}`;
  }
  return paymentToken;
};

const getBanTitle = (address) => {
  const banId = address?.additionalInfo?.banId;
  return banId ? `חשבון ${banId}` : 'חשבון קיים';
};

const getBanDescription = (address) =>
  address?.additionalInfo?.productDescription?.shortDescription ||
  address?.additionalInfo?.productDescription?.description ||
  '';

const getBanPaymentLine = (address) => {
  const info = address?.additionalInfo || {};
  const token = formatPaymentToken(info.paymentType, info.paymentToken);
  if (info.paymentType === 'CREDIT_CARD' && token) {
    return `מחויב בכרטיס אשראי ${token}`;
  }
  if (info.paymentType === 'BANK' && token) {
    return `מחויב בחשבון בנק ${token}`;
  }
  if (info.paymentType === 'PAYPAL' && token) {
    return `מחויב ב-PayPal ${token}`;
  }
  return token || 'אמצעי תשלום קיים';
};

const InternetBanSelectView = ({ bans = [], draftSelection, onSelectDraft }) => {
  return (
    <div className='internet-ban-select'>
      <div className='internet-ban-select__list' role='radiogroup' aria-label='בחירת אמצעי תשלום'>
        {bans.map((address) => {
          const banId = address?.additionalInfo?.banId;
          const isSelected = draftSelection !== NEW_PAYMENT_OPTION && draftSelection === banId;
          return (
            <button
              key={banId || JSON.stringify(address)}
              type='button'
              className={`internet-ban-select__option${isSelected ? ' internet-ban-select__option--selected' : ''}`}
              onClick={() => onSelectDraft(banId)}
            >
              <input
                className='internet-ban-select__radio'
                type='radio'
                name='internet-ban-select'
                checked={isSelected}
                onChange={() => onSelectDraft(banId)}
                tabIndex={-1}
              />
              <div className='internet-ban-select__option-body'>
                <p className='internet-ban-select__option-title'>{getBanTitle(address)}</p>
                {getBanDescription(address) ? (
                  <p className='internet-ban-select__option-text'>{getBanDescription(address)}</p>
                ) : null}
                <p className='internet-ban-select__option-text'>{getBanPaymentLine(address)}</p>
              </div>
            </button>
          );
        })}

        <button
          type='button'
          className={`internet-ban-select__option${
            draftSelection === NEW_PAYMENT_OPTION ? ' internet-ban-select__option--selected' : ''
          }`}
          onClick={() => onSelectDraft(NEW_PAYMENT_OPTION)}
        >
          <input
            className='internet-ban-select__radio'
            type='radio'
            name='internet-ban-select'
            checked={draftSelection === NEW_PAYMENT_OPTION}
            onChange={() => onSelectDraft(NEW_PAYMENT_OPTION)}
            tabIndex={-1}
          />
          <div className='internet-ban-select__option-body'>
            <p className='internet-ban-select__option-title'>הוספת אמצעי תשלום חדש</p>
          </div>
        </button>
      </div>
    </div>
  );
};

export { NEW_PAYMENT_OPTION, formatPaymentToken, getBanDescription };
export default InternetBanSelectView;
